module.exports = __webpack_public_path__ + "img/goods8_5.bced8640.jpg";